import React, { useState } from 'react';
import { TopContentResult } from '../AbstractComboBox/types/SuggestResultTypes';
import { SuggestComboBox, SuggestComboBoxProps } from '../AbstractComboBox/SuggestComboBox';
import ListItemPage from '../AbstractComboBox/ListItemPage/ListItemPage';
import getContentTopResults from './getContentTopResult';
import { useHtmlValidId } from '../../../../../../hooks/useHtmlValidId';
import { Row } from '../../../../../../_lib/Form2';
import { ContentPreview } from '../ContentPreview/ContentPreview';
import { useSonTranslation } from '../../../../../../translation/useSonTranslation';

export default function ContentSelectComboBox(props: SuggestComboBoxProps<TopContentResult>) {
  return (
    <SuggestComboBox {...props} responseMapper={getContentTopResults}>
      {item => <ListItemPage page={item} />}
    </SuggestComboBox>
  );
}

interface ContentSelectComboBoxForForm2Props
  extends Omit<SuggestComboBoxProps<TopContentResult>, 'id' | 'onSelection' | 'validationMessage'> {
  valueKey?: string;
}

/**
 * Form2 compatible ContentSelectComboBox.
 * As with most comboboxes the name of the input should not be set.
 * Here we use the name as the hidden input for the selected page
 * Combobox is responsible to set hidden param, html conform json payload.
 */
export function ContentSelectComboBoxForForm2(props: ContentSelectComboBoxForForm2Props) {
  const id = useHtmlValidId();
  const { t } = useSonTranslation('FormsComboBox');
  const [result, setResult] = useState<TopContentResult | undefined>(props.selected);

  const { valueKey } = props;

  return (
    <>
      <Row>
        <SuggestComboBox
          {...props}
          name={undefined} // need to overwrite name here after we spread props !
          id={`content-select-combobox-${id}`}
          responseMapper={getContentTopResults}
          onSelection={page => setResult(page as TopContentResult)}
          validationMessage={props.required && !result ? t('content.validationMessage') : undefined}
        >
          {item => <ListItemPage page={item as TopContentResult} />}
        </SuggestComboBox>
      </Row>

      {result && (
        <>
          <input
            type="hidden"
            name={props.name}
            // @ts-expect-error TopContentResult type can't anticipate unknown string key.
            value={valueKey ? result[valueKey] : result.id}
          />
          <ContentPreview {...result} reset={() => setResult(undefined)} />
        </>
      )}
    </>
  );
}
